import { useEffect, useState } from "react"

import { isEqual } from "lodash"
import { Button, cn } from "twyne-new.ui"

import { useCraftProp } from "../../utils"

const ApplyButtonPopover = ({ onApply, onCancel, name, value, className = '' }) => {
  const [disabled, setDisabled] = useState(true)
  const { value: craftValue } = useCraftProp(name)

  useEffect(() => {
    setDisabled(isEqual(craftValue, value))
  }, [craftValue, value])

  return <>
    <div className={cn('flex gap-2 items-center w-full', className)}>
      <Button block color='accent' onClick={onApply} disabled={disabled}>Apply</Button>
      <Button block color='neutral' variant='outline' onClick={onCancel}>Cancel</Button>
    </div>
  </>
}

export default ApplyButtonPopover
